<div [class]="customClasses().formGroup">
  <label [class]="customClasses().label" [class.disabled]="ngControl.disabled">
    {{ label() }}
    @if (inputRequiredIndicatorEnabled()) {
      <span class="text-danger"> *</span>
    }
  </label>

  <div
    class="di-field"
    [class.di-field--invalid]="ngControl.touched && ngControl.invalid"
    [class.di-field--disabled]="ngControl.disabled"
  >
    <span class="mdi mdi-calendar-month-outline di-icon"></span>
    <input
      class="di-input"
      type="text"
      [placeholder]="placeholder()"
      [bsValue]="(ngControl.control | formControl)?.value"
      [disabled]="ngControl.disabled ?? false"
      [minDate]="minDate()"
      [maxDate]="maxDate()"
      [bsConfig]="bsConfig()"
      bsDatepicker
      container="body"
      readonly
      (bsValueChange)="onValueChange($event)"
      (blur)="onInputBlur()"
      [attr.data-qa]="testAutomationSelectorName()"
    />
    <span class="mdi mdi-chevron-down di-chevron"></span>
  </div>

  <div class="field-error-slot">
    @if (ngControl.touched && ngControl.control?.errors?.['required']) {
      <div class="invalid-feedback d-block">
        {{ label() | titlecase }} cannot be empty
      </div>
    }
  </div>
</div>
